import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import ScrollAdd from '../components/ScrollAdd';
import Navbar from "../components/Navbar";
import { API_BASE } from "../api";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {

    
  const [data,setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(()=>{

    const transactionId = localStorage.getItem("txn");

    if (!transactionId) {
      setError("No transaction details found.");
      return;
    }

    fetch(`${API_BASE}/api/enroll/details/${transactionId}`)
    .then(res => {
      if (!res.ok) throw new Error("Could not fetch enrollment details.");
      return res.json();
    })
    .then(d => setData(d))
    .catch(err => {
      console.error(err);
      setError(err.message);
    });

  },[])

  if(error) return (
    <div style={{ textAlign: "center", padding: "100px 20px" }}>
      <Navbar/>
      <h1 style={{color:"red"}}>Error</h1>
      <p>{error}</p>
      <button onClick={()=>window.location.href="/"} className="button-2">Go Home</button>
      <Footer/>
    </div>
  );

  if(!data) return <div>Loading...</div>;


  return (
    <>
      <ScrollAdd />
      <Navbar />
      <div className="success-card print-area">
        <div className="success-icon">✔</div>
        <h1 className="success-title">Enrollment Successful</h1>
        <p className="success-subtitle">
          Your enrollment has been confirmed. You can download your invoice below.
        </p>

        {/* Print Only Header */}
        <div className="invoice-header-print">
          <img src="/images/LEARNORAMA-LOGO.png" alt="Learnorama Logo" className="invoice-logo" />
          <div className="invoice-title-print">
            <h1>INVOICE</h1>
            <p>Date: {new Date().toLocaleDateString()}</p>
            <p>Invoice #: {data.EnrollmentCode}</p>
          </div>
        </div>

        <div className="invoice-preview">
          <h3>Enrollment Details</h3>

          {/* Print Only Billing Grid */}
          <div className="invoice-details-grid">
            <div className="billing-section">
              <h4>Billed To:</h4>
              <p><b>Name:</b> {data.ParentName || data.ChildName}</p>
              <p><b>Contact:</b> {data.ContactNumber}</p>
            </div>
            <div className="billing-section">
              <h4>Payment Info:</h4>
              <p><b>Transaction ID:</b> {data.MerchantTransactionId}</p>
              <p><b>Method:</b> Razorpay</p>
              <p><b>Status:</b> {data.PaymentStatus}</p>
            </div>
          </div>

          <div className="invoice-row">
            <span className="invoice-label">Enrollment Code</span>
            <span className="invoice-value">{data.EnrollmentCode}</span>
          </div>
          <div className="invoice-row">
            <span className="invoice-label">Transaction ID</span>
            <span className="invoice-value">{data.MerchantTransactionId}</span>
          </div>
          <div className="invoice-row">
            <span className="invoice-label">Child Name</span>
            <span className="invoice-value">{data.ChildName}</span>
          </div>
          <div className="invoice-row">
            <span className="invoice-label">Camp Name</span>
            <span className="invoice-value">{data.CampName}</span>
          </div>
          <div className="invoice-row">
            <span className="invoice-label">Fees Paid</span>
            <span className="invoice-value">₹{data.Amount.toLocaleString()}</span>
          </div>
          <div className="invoice-row">
            <span className="invoice-label">Payment Status</span>
            <span className="invoice-value" style={{ color: '#27ae60' }}>{data.PaymentStatus}</span>
          </div>
        </div>

        <div className="action-buttons">
          <button onClick={() => window.print()} className="print-btn">
            Download Invoice
          </button>
          <button onClick={() => window.location.href = "/"} className="home-btn">
            Go Home
          </button>
        </div>

        {/* Print Only Footer */}
        <div className="print-footer">
          <p>Learnorama Technologies Pvt Ltd | info@learnorama.in | www.learnorama.in</p>
          <p>Thank you for choosing Learnorama for your child's summer adventure!</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentSuccess;
